<template>
    <div class="container">
        <template>
            <section>
              &nbsp;
              <br>
            </section>
            <section>



                <div v-if="visibleMain">
                    <div class="columns">
                        <div class="column">
                            <div class="card">
                                <div class="card-image">
                                    <figure class="image is-4by3">
                                        <img src="@/assets/cards/1.jpg" alt="Card image" >
                                    </figure>
                                </div>
                                <div class="card-content">
                                  <p class="is-size-4 has-text-primary"> รายงานตัวเลขในเชิงสถิติพรรณา </p>
                                </div>
                                <footer class="card-footer">
                                    <b-button type="is-success is-light"  icon-left="magnify"  class="card-footer-item" @click="viewReport(1)"> View </b-button>
                                </footer>
                            </div>
                        </div>
                        <div class="column">
                            <div class="card">
                                <div class="card-image">
                                    <figure class="image is-4by3">
                                        <img src="@/assets/cards/2.jpg" alt="Card image">
                                    </figure>
                                </div>
                                <div class="card-content">
                                    <p class="is-size-4 has-text-primary"> รายงานจำนวน Diagnosis Code </p>
                                </div>
                                <footer class="card-footer">
                                    <b-button type="is-success is-light"  icon-left="magnify"  class="card-footer-item" @click="viewReport(2)"> View </b-button>
                                </footer>
                            </div>
                        </div>
                    </div>

                    <div class="columns">
                        <div class="column">
                            <div class="card">
                                <div class="card-image">
                                    <figure class="image is-4by3">
                                        <img src="@/assets/cards/3.jpg" alt="Card image">
                                    </figure>
                                </div>
                                <div class="card-content">
                                    <p class="is-size-4 has-text-primary"> รายงานปริมาณ Workload </p>
                                </div>
                                <footer class="card-footer">
                                    <b-button type="is-success is-light"  icon-left="magnify"  class="card-footer-item"   @click="viewReport(3)"> View </b-button>
                                </footer>
                            </div>
                        </div>
                        <div class="column">

                        </div>
                    </div>
                </div>


               <div v-if="visible001">
                  <Report001 @close="close001" />
               </div>


                <div v-if="visible002">
                    <Report002 @close="close001" />
                </div>

                <div v-if="visible003">
                    <Report003 @close="close001" />
                </div>


            </section>
        </template>
    </div>
</template>


<script>

    import Report001 from "./Report001";
    import Report002 from "./Report002";
    import Report003 from "./Report003";

    export default {
        name: "ReportsDashboard",
        components:{
            Report001,
            Report002,
            Report003
        },
        methods:{
            close001(){
                this.visible001 = false
                this.visible002 = false
                this.visible003 = false
                this.visibleMain = true
            },
            viewReport(id){
                // window.open("http://192.168.1.34:8080/reports001", "_blank");
                this.visibleMain = false
                this.visible001 = false
                this.visible002 = false
                this.visible003 = false

                if(id === 1){
                    this.visible001 = true
                }else if(id === 2){
                    this.visible002 = true
                }else if(id === 3)
                    this.visible003 = true
            }
        },
        data(){
            return{
                visibleMain : true,
                visible001 : false,
                visible002 : false,
                visible003 : false,
            }
        }
    }
</script>

<style scoped>
    img {
        opacity: 1;
        width: 80px;
        height: 80px;
    }
</style>